import { Box, Typography } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import type { Bank } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  bank: Bank;
};

export const Email = ({ bank }: Props) => {
  const { t } = useResource();

  return (
    <Box>
      <Typography display="inline" fontWeight="500">
        {t(Resources.BankRating.Detail.Titles.Email)}{" "}
        <UnstyledLink
          to={`mailto:${t(Resources.BankRating.Banks[bank].Email)}`}
        >
          {t(Resources.BankRating.Banks[bank].Email)}
        </UnstyledLink>
      </Typography>
    </Box>
  );
};
